<template>
  <div>
    <router-view></router-view>
    <van-tabbar
      class="bottom-nav"
      v-model="active"
      active-color="#7469F8"
      inactive-color="#B3B9D0"
      route
    >
      <van-tabbar-item
        v-if="userType == '2' && schoolCode != '10013'"
        replace
        to="/new/Table"
      >
        <span class="nav-title">课表</span>
        <template #icon="props">
          <img :src="props.active ? icon[0].active : icon[0].inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item
        v-if="userType == '2' && schoolCode == '10013'"
        replace
        to="/new/newTable_10013"
      >
        <span class="nav-title">课表</span>
        <template #icon="props">
          <img :src="props.active ? icon[0].active : icon[0].inactive" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item
        v-if="
          schoolCode == '13977' || (schoolCode == '10008' && userType == '1')
        "
        replace
        to="/surfaces"
      >
        <span class="nav-title">课表</span>
        <template #icon="props">
          <img :src="props.active ? icon[0].active : icon[0].inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item
        v-if="schoolCode == '10013'"
        replace
        to="/new/Home_10013"
      >
        <span class="nav-title">首页</span>
        <template #icon="props">
          <img :src="props.active ? icon[1].active : icon[1].inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-else replace to="/new/Home">
        <span class="nav-title" v-if="schoolCode == '10541'">服务</span>
        <span class="nav-title" v-if="schoolCode == '10054'">首页</span>
        <span class="nav-title" v-else>工具</span>
        <template #icon="props">
          <img :src="props.active ? icon[1].active : icon[1].inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-if="schoolCode == '10013'" replace to="/new/Msg1">
        <span class="nav-title">消息通知</span>
        <template #icon="props">
          <div class="dot">
            <img :src="props.active ? icon[2].active : icon[2].inactive" />
            <span class="red-dot">{{ length }}</span>
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-if="schoolCode === '10488'" replace to="/new/Msg_10488" @click="getXjyj()">
        <span class="nav-title">通知</span>
        <template #icon="props">
          <div class="dot">
            <img :src="props.active ? icon[2].active : icon[2].inactive" />
            <span v-if="wdxx > 0"
              class="red-dot"
              >{{ wdxx }}</span
            >
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-else replace to="/new/Msg" @click="getXjyj()">
        <span class="nav-title">消息</span>
        <template #icon="props">
          <div class="dot">
            <img :src="props.active ? icon[2].active : icon[2].inactive" />
            <span v-if="schoolCode == '10555'" class="red-dot">{{
              length_10555
            }}</span>
            <span v-if="schoolCode == '14246' && xjyj > 0" class="red-dot"
              >!</span
            >
            <span
              v-if="wdxx > 0 && schoolCode != '14246' && schoolCode != '10555'"
              class="red-dot"
              >{{ wdxx }}</span
            >
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/new/person">
        <span class="nav-title">我的</span>
        <template #icon="props">
          <img :src="props.active ? icon[3].active : icon[3].inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      active: -1,
      userType: "",
      icon: [
        {
          active: "./static/image/time1.png",
          inactive: "./static/image/time.png"
        },
        {
          active: "./static/image/tool1.png",
          inactive: "./static/image/tool.png"
        },
        {
          active: "./static/image/msg1.png",
          inactive: "./static/image/msg.png"
        },
        {
          active: "./static/image/my1.png",
          inactive: "./static/image/my.png"
        }
      ],
      schoolCode: "",
      length: "0",
      length_10555: "0",
      xjyj: 0,
      wdxx: 0
    };
  },
  methods: {
    // 判断用户类型更改设置
    userConfig() {
      let list = JSON.parse(sessionStorage.getItem("userInfo"));
      if (list && list.userType) {
        this.userType = list.userType;
      }
      if (this.userType == "2") {
        this.active = 1;
      } else {
        this.active = 0;
      }
    },
    async getLength() {
      if (this.userType == "2") {
        const res = await Api.getxssqjl();
        this.length = res.data.length;
      } else {
        const res = await Api.getNotShenHeMsg();
        this.length = res.data.length;
      }
    },
    async getLength_10555() {
      if (this.userType != "2") {
        const res = await Api.dsNoticeList();
        // const ret = await Api.getAdvList();
        if (res.code == "1") {
          this.length_10555 = res.data.length;
        }
        // if (ret.code == "1") {
        //   this.length_10555 = this.length_10555 + ret.data.length;
        // }
      }
    },
    async getXjyj() {
      if (this.schoolCode == "14246") {
        const res = await Api.getMsgApi();
        if (res.code == "1") {
          this.xjyj = res.data[0].xjyj;
        }
      }
    },
    async getwdXx() {
      const res = await Api.getMsgApi();
      if (res.code == "1") {
        this.wdxx = res.data[0].unReadNum;
        if (res.gglyNbData) {
          this.wdxx = this.wdxx * 1 + res.gglyNbData * 1;
        }
      }
    }
  },
  created() {
    this.getwdXx();
    // 判断用户类型更改设置
    if (sessionStorage.getItem("userType")) {
      this.userType = sessionStorage.getItem("userType");
    }
    this.userConfig();
    this.schoolCode = sessionStorage.getItem("schoolCode");
    if (this.schoolCode == "10013") {
      this.getLength();
    }
    if (this.schoolCode == "10555") {
      this.getLength_10555();
    }
    if (this.schoolCode == "14246") {
      this.getXjyj();
    }
  }
};
</script>
<style lang="less" scoped>
.dot {
  position: relative;
  .red-dot {
    position: absolute;
    background-color: red;
    color: #ffffff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    left: 80%;
    bottom: 50%;
  }
}
.bottom-nav {
  width: 100%;
  height: 49px;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  z-index: 999 !important;

  .nav-title {
    width: 22px;
    height: 16px;
    font-family: PingFangSC-Regular;
    font-size: 11px;
    letter-spacing: 0;
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
.bottom-nav {
  z-index: 999;
  .van-icon-like,
  .van-icon-like-o {
    font-family: "iconfont" !important;
    font-size: 26px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .van-icon-like::before {
    content: "\e6b7";
  }
  .van-icon-like-o::before {
    content: "\e6c0";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/Home/HomeBar.vue